import { formatDateSaveDB } from "../../../../../../../../utils/getDate"
import { SchedulesExportFRM103PostType } from "../../../../../models/list/export"
import { SchedulesSearchFormDataType } from "../../../../../models/list/search"

export const convertDataSearch = ({
  arrivalDateTimeDate,
  departureDateTimeDate,
  transitSearchType,
  ...values
}: SchedulesSearchFormDataType): SchedulesExportFRM103PostType => ({
  ...values,
  arrivalDateTime: arrivalDateTimeDate
    ? formatDateSaveDB(arrivalDateTimeDate.toString(), true)
    : "",
  departureDateTime: departureDateTimeDate
    ? formatDateSaveDB(departureDateTimeDate.toString())
    : "",
  transitSearchType,
})
